import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import type { UUID } from "../../../utils/uuid";
import {
  SupabaseDigitalAssetService,
  toMaybeAsset,
  type Asset,
} from "../../assets/server/digital-asset-service";

export const useAsset = (id: UUID | null): UseSupabaseLoaderState<Asset | null> => {
  return useSupabaseLoader(
    async ({ supabase }) => {
      if (!id) return null;
      const { data, error } = await new SupabaseDigitalAssetService(supabase).get(id);
      if (error) throw new Error(error.message);
      return toMaybeAsset(data);
    },
    [id],
  );
};
